import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=380f8991&scoped=true"
import script from "./LocationForm.vue?vue&type=script&lang=js"
export * from "./LocationForm.vue?vue&type=script&lang=js"
import style0 from "./LocationForm.vue?vue&type=style&index=0&id=380f8991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f8991",
  null
  
)

export default component.exports